import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import $ from 'jquery';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';

const CLOSED_FILTER_GROUPS_IDS_KEY = 'closedFilterGroupsIdsKey';

@Directive({
    selector: '[appCollapse]',
})
export class CollapseDirective implements AfterViewInit {
    private collapseBody;
    private element;

    @Input() shouldBeExpanded: boolean;
    @Input() filterGroupId?: number;

    constructor(
        private elementRef: ElementRef,
        private windowRef: WindowRef,
    ) {}

    ngAfterViewInit() {
        this.element = $(this.elementRef.nativeElement);
        setTimeout(() => {
            this.collapseBody = $(this.element).find('.collapse-body');

            if (this.element.parents('app-left-menu').length) {
                if (this.collapseBody.find('.active').length || this.shouldBeExpanded) {
                    this.element.addClass('expanded');
                    this.element.find('.collapse-body').show();
                } else {
                    if (this.filterGroupId || this.filterGroupId === 0) {
                        let isNeedToCollapseItem = false;
                        if (HelperService.isLocalStorageNameSupported()) {
                            const closedGroupsIdsStr =
                                this.windowRef.nativeWindow.localStorage.getItem(CLOSED_FILTER_GROUPS_IDS_KEY);

                            if (closedGroupsIdsStr) {
                                const closedGroupsIds = JSON.parse(closedGroupsIdsStr);
                                if (closedGroupsIds.includes(this.filterGroupId)) {
                                    isNeedToCollapseItem = true;
                                }
                            }
                        }

                        if (isNeedToCollapseItem) {
                            this.element.removeClass('expanded');
                            this.collapseBody.hide();
                        } else {
                            this.element.addClass('expanded');
                            this.element.find('.collapse-body').show();
                        }
                    } else {
                        this.element.removeClass('expanded');
                        this.collapseBody.hide();
                    }
                }
            } else {
                if (this.element.hasClass('expanded') && !this.collapseBody.is(':visible')) {
                    this.collapseBody.slideDown('100', () => {
                        // You may toggle + - icon
                    });
                }
            }
        }, 1);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.element.click((event) => {
            if (
                $(event).closest('.ticket-right-panel-collapsed').length > 0 ||
                event.originalEvent.metaKey ||
                event.originalEvent.ctrlKey
            ) {
                return true;
            }

            event.stopPropagation();

            if ($(event.target).closest('.collapse-header').length === 0) {
                return false;
            }

            this.toggleCollapse();

            if (this.element.closest('.accordeon').length > 0 && $('div.collapse-body:visible').length > 1) {
                $(this).siblings().removeClass('expanded');

                $(this)
                    .siblings()
                    .find('.collapse-body')
                    .slideUp('slow', function () {
                        $(this).find('.expanded').removeClass('expanded').find('.collapse-body').hide();
                    });
            }
        });
    }

    toggleCollapse() {
        this.collapseBody = this.element.find('.collapse-body').first();
        const isCollapsed = !this.collapseBody.is(':visible');

        if (isCollapsed) {
            this.element.addClass('expanded');
        } else {
            this.element.removeClass('expanded');
        }

        // $(element).find(".icon-arrow").toggleClass('toggled');
        this.collapseBody.slideToggle('100', () => {
            setTimeout(() => {
                if (this.element.offset().top < 0) {
                    $('md-sidenav').scrollTop(0);
                    // $('md-sidenav').animate({
                    //    scrollTop: 0
                    // }, 200);
                }
            }, 100);
        });

        if ((this.filterGroupId || this.filterGroupId === 0) && HelperService.isLocalStorageNameSupported()) {
            let closedGroupsIds: number[] = [];
            const closedGroupsIdsStr = this.windowRef.nativeWindow.localStorage.getItem(CLOSED_FILTER_GROUPS_IDS_KEY);

            if (closedGroupsIdsStr) {
                closedGroupsIds = JSON.parse(closedGroupsIdsStr);
            }

            if (isCollapsed) {
                if (closedGroupsIds.length) {
                    const index = closedGroupsIds.indexOf(this.filterGroupId);

                    if (index > -1) {
                        closedGroupsIds.splice(index, 1);
                    }
                }
            } else {
                if (!closedGroupsIds.includes(this.filterGroupId)) {
                    closedGroupsIds.push(this.filterGroupId);
                }
            }

            this.windowRef.nativeWindow.localStorage.setItem(
                CLOSED_FILTER_GROUPS_IDS_KEY,
                JSON.stringify(closedGroupsIds),
            );
        }
    }
}
